import { post } from '../axios'

export const checkTransaction = params => post('/openapi/verification/v1/employment/checkTransaction', params)
